const axios = require("axios").default;

const URL = `${process.env.REACT_APP_API_URL}/query/sp/sp_ViewReturnDetail`;
const URL_PARAM = `${process.env.REACT_APP_API_URL}/param`;
const URL_ITEM = `${process.env.REACT_APP_API_URL}/return/items`;

// export const getAll = (payload) => {
//   return axios.get(URL, {
//     params: payload,
//   });
// };

export const getAll = (payload) => {
  return axios
    .get(URL_ITEM, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getId = (id) => {
  return axios
    .get(`${URL_ITEM}/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getParam = (payload) => {
  return axios.get(URL_PARAM, {
    params: payload,
  });
};
